module.exports = __webpack_public_path__ + "static/advice-d0b977ab6dbbb3c6d4777519ef05fc62.png";